import type { GridResize } from '../../hooks/useGridResize'

/**
 * Absolute-positioned drag handles laid over the internal grid lines of a
 * resizable chart grid. Render as the last children of the `relative` grid
 * container that uses `grid.gridRef` / `grid.gridTemplate*`.
 */
export function GridDividers({ grid }: { grid: GridResize }) {
  const { colFracs, rowFracs, startDrag } = grid
  const colTotal = colFracs.reduce((a, b) => a + b, 0)
  const rowTotal = rowFracs.reduce((a, b) => a + b, 0)
  let colAcc = 0
  let rowAcc = 0

  return (
    <>
      {colFracs.slice(0, -1).map((f, i) => {
        colAcc += f
        return (
          <div
            key={`col-${i}`}
            onPointerDown={startDrag('col', i)}
            className="group absolute top-0 bottom-0 z-20 w-2 -translate-x-1/2 cursor-col-resize touch-none"
            style={{ left: `${(colAcc / colTotal) * 100}%` }}
          >
            <div className="absolute inset-y-0 left-1/2 w-px -translate-x-1/2 bg-transparent group-hover:bg-sky-500" />
          </div>
        )
      })}
      {rowFracs.slice(0, -1).map((f, i) => {
        rowAcc += f
        return (
          <div
            key={`row-${i}`}
            onPointerDown={startDrag('row', i)}
            className="group absolute left-0 right-0 z-20 h-2 -translate-y-1/2 cursor-row-resize touch-none"
            style={{ top: `${(rowAcc / rowTotal) * 100}%` }}
          >
            <div className="absolute inset-x-0 top-1/2 h-px -translate-y-1/2 bg-transparent group-hover:bg-sky-500" />
          </div>
        )
      })}
    </>
  )
}
